import React from "react";
import { Route, Switch } from "react-router";
import {
  Home,
  SignIn,
  SignUp,
  Reset,
  BoothList,
  BoothMap,
  BoothDetail,
  BoothEdit,
  OpusEdit,
  OpusList,
  MyPage,
  Account,
  NotificationsList,
  MovieEdit,
  MovieList,
  QuestionList,
  OpusDetail,
  OrganizerPage,
  AvatarEdit,
  ProfileEdit,
  PolicyPage,
  MailEdit,
  PasswordEdit,
  DeleteUser,
  // EnterPage,
} from "./templates";
import Auth from "./Auth";

const Router = () => {
  return (
    <Switch>
      <Route exact path={"(/)?"} component={Home} />
      {/* <Route exact path={"(/)?"} component={EnterPage} /> */}
      <Route exact path={"/signup"} component={SignUp} />
      <Route exact path={"/signin"} component={SignIn} />
      <Route exact path={"/signin/reset"} component={Reset} />
      <Route exact path={"/boothmap"} component={BoothMap} />
      <Route exact path={"/boothlist"} component={BoothList} />
      <Route exact path={"/boothlist/:id"} component={BoothDetail} />
      <Route exact path={"/opus/detail/:id"} component={OpusDetail} />
      <Route exact path={"/policy"} component={PolicyPage} />
      <Auth>
        <Route exact path={"/opuslist"} component={OpusList} />
        <Route exact path={"/questionlist"} component={QuestionList} />
        <Route path={"/movie/edit(/:id)?"} component={MovieEdit} />
        <Route exact path={"/movielist"} component={MovieList} />
        <Route exact path={"/Account"} component={Account} />
        <Route exact path={"/mailEdit"} component={MailEdit} />
        <Route exact path={"/passwordEdit"} component={PasswordEdit} />
        <Route exact path={"/deleteUser"} component={DeleteUser} />
        <Route exact path={"/Notification"} component={NotificationsList} />
        <Route exact path={"/mypage/:id"} component={MyPage} />
        <Route path={"/organizer/:id"} component={OrganizerPage} />
        <Route path={"/booth/edit(/:id)?"} component={BoothEdit} />
        <Route path={"/opus/edit(/:id)?"} component={OpusEdit} />
        <Route path={"/avatar/edit(/:id)?"} component={AvatarEdit} />
        <Route path={"/profile/edit(/:id)?"} component={ProfileEdit} />
      </Auth>
    </Switch>
  );
};

export default Router;
